import { motion, MotionProps } from "framer-motion";
import "./BookFeaturesListItem.css";
import { FC } from "react";
import { DynamicText } from "@tennr/frontend/components/DynamicText";

interface BookFeaturesListItemProps {
  title: string;
  body: string;
  id: string;
  active: boolean;
  setActive: () => void;
  titleMotion?: MotionProps;
  bodyMotion?: MotionProps;
}

export const BookFeaturesListItem: FC<BookFeaturesListItemProps> = ({
  title = "",
  body = "",
  id,
  active,
  setActive,
  titleMotion,
  bodyMotion,
}) => {
  function handleKeyDown(e: KeyboardEvent) {
    if (e.code === " " || e.code === "Enter") setActive();
  }

  return (
    <div
      className={`book-features-list-item ${active ? "book-features-list-item-active" : "book-features-list-item-inactive"}`}
    >
      <motion.div
        className="book-features-list-item-title"
        {...titleMotion}
        aria-controls={id}
        aria-expanded={active}
        role="button"
        tabIndex={0}
        onClick={setActive}
        onKeyDown={(e) => handleKeyDown(e)}
      >
        <img src="/svg/rhombus.svg" alt="" className="book-features-list-item-bullet" draggable={false} />
        <DynamicText as="span">{title}</DynamicText>
      </motion.div>
      <motion.div id={id} className="book-features-list-item-detail" {...bodyMotion}>
        <DynamicText as="p" className="book-features-list-item-body">
          {body}
        </DynamicText>
        <img
          src={`/svg/book-features-list-item-${id}.svg`}
          alt=""
          className="book-features-list-item-image"
          draggable={false}
        />
      </motion.div>
    </div>
  );
};
